import { useState } from "react";
import { clearLocalData, isLocalStorageSupported } from "../storage/localStore";

interface LocalDataControlsProps {
  canSave: boolean;
  onSave: () => Promise<void>;
}

export function LocalDataControls({ canSave, onSave }: LocalDataControlsProps) {
  const [message, setMessage] = useState<string | null>(null);
  const supported = isLocalStorageSupported();

  async function handleSave() {
    try {
      await onSave();
      setMessage("Cambios guardados en este navegador (IndexedDB).");
    } catch {
      setMessage("No se pudo guardar localmente. Tus datos no salieron del navegador.");
    }
  }

  async function handleClear() {
    await clearLocalData();
    setMessage("Datos locales eliminados.");
  }

  if (!supported) {
    return <p className="field-hint">Este navegador no soporta almacenamiento local; la sesión vive solo en memoria.</p>;
  }

  return (
    <div className="action-row" aria-live="polite">
      <button
        type="button"
        className="button button-secondary button-small"
        onClick={() => {
          void handleSave();
        }}
        disabled={!canSave}
      >
        Guardar cambios en este navegador
      </button>
      <button
        type="button"
        className="button button-danger button-small"
        onClick={() => {
          void handleClear();
        }}
      >
        Eliminar datos locales
      </button>
      {message ? <span className="field-hint">{message}</span> : null}
    </div>
  );
}
